import { z } from 'zod';
import { AgenticPlatformCallbackOperation } from './callbackScope.js';
/**
 * The explicit ceiling on what agentic-platform may do for a user. Empty lists grant nothing;
 * they never mean all organizations or operations. Signing validates the shape, not approval:
 * primary must authorize the grant before handing it to the token helper.
 */
export const AgenticPlatformCallbackGrantSchema = z.object({
    userId: z.uuid(),
    // Organization ids are compared as lowercase strings, as the database returns them.
    organizationIds: z.array(z.uuid().transform((organizationId) => organizationId.toLowerCase())),
    operations: z.array(z.enum(AgenticPlatformCallbackOperation)),
});
/** Minting accepts only the grant; the issuer controls expiration and token version. */
export const ProxiedIdentitySchemaV1 = AgenticPlatformCallbackGrantSchema.extend({
    exp: z.number(),
    // Future delegation-backed formats must not bypass their approval checks in an older verifier.
    tokenVersion: z.literal(1),
});
export const ProxiedIdentitySchemaV2 = AgenticPlatformCallbackGrantSchema.extend({
    exp: z.number(),
    tokenVersion: z.literal(2),
    userId: z.uuid().transform((value) => value.toLowerCase()),
    sessionId: z.uuid().transform((value) => value.toLowerCase()),
});
export const ProxiedIdentitySchema = z.discriminatedUnion('tokenVersion', [
    ProxiedIdentitySchemaV1,
    ProxiedIdentitySchemaV2,
]);
//# sourceMappingURL=proxiedIdentity.js.map